import React, { useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";

const AccessToken = ({ loginSaml }) => {
  let location = useLocation();
  const hash = location.hash;
  const hasDispatched = useRef(false);

  useEffect(() => {
    if (hasDispatched.current) return;

    const hashParams = new URLSearchParams(hash.replace(/^#/, ""));
    const token = hashParams.get("access_token");
    const error = hashParams.get("error");

    if (error) {
      hasDispatched.current = true;
      loginSaml({ error: "error" });
      return;
    }

    if (token) {
      hasDispatched.current = true;
      loginSaml({ token });
    }
  }, [hash, loginSaml]);

  return (<></>);
};

export default AccessToken;
